<script setup>
import { computed, onBeforeUnmount, onMounted,getCurrentInstance } from 'vue';
import { useDrawerMenu } from '../useDrawerMenu.js'
import Plugin from '../plugin.js'

const props = defineProps({
    menuComponent: {
        type: [Object, Function, String],
        required: true,
    },
    menuComponentProps: {
        type: Object,
        default: () => ({}),
    },
});

const { isOpen, open, close, toggle, moveToPage } = useDrawerMenu();

// mounted() で直接コンポーネントのメソッドを参照できるようにする
const instance = getCurrentInstance();

onBeforeUnmount(() => {
    Plugin.setInstance(null)
});

onMounted(() => {
    Plugin.setInstance(instance?.exposed ?? null); // または このコンポーネント自体の参照

    const stopPropagationElms = document.getElementsByClassName("js-stop_propagation");
    Array.prototype.forEach.call(stopPropagationElms, (elm) => {
        elm.addEventListener("click", (e) => {
            e.stopPropagation();
        }, false);
    });
});

function handleLinkClick(e) {
    const linkElement = e.target.closest('a');
    if (linkElement) {
        const shouldNavigate = moveToPage(linkElement);
        if (!shouldNavigate) {
            e.preventDefault();
        }
    }
}

const resolvedMenuProps = computed(() => ({
    ...props.menuComponentProps,
    onClick: handleLinkClick,
}));


defineExpose({
    open,
    close,
    toggle,
    moveToPage,
    isOpen
});

defineOptions({
    name: 'DrawerMenu',
});
</script>

<template>
<!--    TODO: is-drawer-openis-drawer-close-->
    <div class="l-drawer_menu-inner" @click.prevent="close">
        <div class="drawer_menu js-stop_propagation">
            <a class="drawer_menu-close" @click.prevent="close"></a>
            <component :is="menuComponent" v-bind="resolvedMenuProps" />
        </div>
    </div>
</template>

<style scoped>
</style>
